<template>
  <IndexPageSection
    v-if="showableSpecials"
    :link-string="'一覧へ'"
    :link-url="'/announcements/specials'"
    :need-to-move-link-to-bottom="false"
    :section-name="'special-list-section'"
    :title="'特集・キャンペーンから探す'"
    @click-link="onClickSectionHeaderLink"
  >
    <HorizontalScroll ref="special-list-horizontal" ref-name="special-list">
      <SpecialList :specials="specials" @mount="onMountSpecialList" />
    </HorizontalScroll>
  </IndexPageSection>
</template>
<script>
import IndexPageSection from './IndexPageSection.vue'
import SpecialList from './specials/SpecialList.vue'
import axios from 'axios'
import HorizontalScroll from '../../../molecules/horizontal-scrolls/HorizontalScroll.vue'
export default {
  components: { HorizontalScroll, IndexPageSection, SpecialList },
  data() {
    return {
      specials: [],
      isLoading: false
    }
  },
  computed: {
    isNotEmptySpecials() {
      return this.specials.length !== 0
    },
    showableSpecials() {
      return !this.isLoading && this.isNotEmptySpecials
    }
  },
  mounted() {
    this.getSpecials()
  },
  methods: {
    onClickSectionHeaderLink() {
      dataLayer.push({
        event: 'click_top__announcement_list'
      })
    },
    async getSpecials() {
      this.isLoading = true
      try {
        const res = await axios.get(
          '/api/v1/pickup/announcements/specials?limit=10'
        )
        this.specials = res.data.data.map(special => ({
          id: special.attributes.id,
          imageUrl: special.attributes.top_image_url
        }))
      } catch (error) {
        const message =
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : '情報の取得に失敗しました。しばらく経ってから再度アクセスしてください'
        this.$emit('error', message)
      }
      this.isLoading = false
    },
    onMountSpecialList() {
      this.$refs['special-list-horizontal'].initializeValues()
    }
  }
}
</script>
